import React from "react";
import { Box, Divider, Stack, Typography } from "digiwash-components";
import { formatNumber, formatPrice } from "digiwash-core";
import { TouchableOpacity } from "react-native";
import CustomIcon from "../CustomIcon";
import BoxRatio from "../BoxRatio";
import { color as colorUtil } from "@sloth-system/styled-utils";
import theme from "../../configs/theme-config";
import { ListServicesType } from "../../types/server";
import ServiceTitle from "../ServiceTitle";
import { calcWidth, findLeastPrice } from "./ServicesItem-helper";
import { useSelector } from "react-redux";
import userSelectors from "../../ducks/user/selectors";

interface ServicesItemType {
  data: ListServicesType;
  onSelect: (arg0: ListServicesType) => void;
  badge: { [key: string]: number };
}

function ServicesItem(props: ServicesItemType) {
  let authenticated: boolean = useSelector(userSelectors.getToken);
  let displayName = [];

  props.data.children.map((item) => {
    displayName.push(item.display_name);
  });

  return (
    <Box
      style={{
        position: "relative",
      }}
    >
      {authenticated && props.badge[props.data.id] ? (
        <Stack
          px="m"
          style={{ position: "absolute", right: 0, zIndex: 10, top: -1 }}
          alignment="start"
        >
          <Box
            bg="orange.light"
            py="s"
            px="m"
            style={{
              borderTopRightRadius: 8,
              borderBottomLeftRadius: 8,
            }}
          >
            <Typography ff="mainBold" color="common.white" fs="xs">
              {formatNumber(props.badge[props.data.id])} سرویس
            </Typography>
          </Box>
          <Box
            style={{
              borderTopWidth: 8,
              borderTopStyle: "solid",
              borderTopColor: "transparent",
              borderRightWidth: 8,
              borderRightStyle: "solid",
              borderRightColor: colorUtil("orange.dark")({ theme: theme }),
              overflow: "visible",
            }}
          />
        </Stack>
      ) : null}

      <Box>
        <TouchableOpacity
          onPress={() => {
            props.onSelect(props.data);
          }}
        >
          <Box bg="primary.light920" br="s">
            <Box p="m">
              <ServiceTitle
                title={props.data.name}
                subtitle={displayName.join("، ")}
              />
            </Box>
            <Divider size="s" />
            <Stack distribution="end">
              <Stack
                bg="common.white"
                distribution="center"
                py="s"
                px="m"
                style={{
                  borderTopRightRadius: 12,
                  borderBottomRightRadius: 12,
                }}
              >
                <Typography fs="xs" color="common.black">
                  {findLeastPrice(props.data) === ""
                    ? "نیاز به کارشناسی"
                    : `از ${formatPrice(findLeastPrice(props.data))} تومان`}
                </Typography>
              </Stack>
            </Stack>
            <Divider size="xm" />
          </Box>
          <Box
            style={{
              width: "40%",
              maxWidth: 80,
              maxHeight: 80,
              position: "absolute",
              right: 0,
              top: "55%",
              zIndex: 1,
            }}
          >
            <BoxRatio ratio="1:1" fixedWidth={calcWidth()}>
              <CustomIcon icon={props.data.alias} width="100%" height="100%" />
            </BoxRatio>
          </Box>
        </TouchableOpacity>
        <Divider size="xxxl" />
      </Box>
    </Box>
  );
}

export default ServicesItem;
